import { useSocketStore } from '@/socket/useSocketStore'

export default function useNotificationsChannel(ws?: any) {
  const tNotificationChannel = ws.getChannel('NotificationsChannel')
  tNotificationChannel.subscribe()
  useSocketStore().sockets['NotificationsChannel'] = tNotificationChannel
}
